module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<span ng-if="::!layertreeCtrl.isRoot">{{::layertreeCtrl.node.name}}</span>\n<input\n  type="checkbox"\n  ng-if="::layertreeCtrl.node && !layertreeCtrl.node.children"\n  ng-model="layertreeCtrl.getSetActive"\n  ng-model-options="{getterSetter: true}"\n/>\n<ul ng-if="::layertreeCtrl.node.children">\n  <li\n    ng-repeat="node in ::layertreeCtrl.node.children"\n    gmf-layertree-node="::node"\n    gmf-layertree-node-notroot\n    gmf-layertree-node-map="layertreeCtrl.map"\n    gmf-layertree-node-nodelayer="layertreeCtrl.nodelayerExpr"\n    gmf-layertree-node-listenersexpr="layertreeCtrl.listenersExpr"\n  ></li>\n</ul>\n';

}
return __p
}